import useFetch from "./useFetch";
import useShortCode from "./useShortCode";
import SubscriptionService from "../services/subscription-service";
import useModuleInfo from "../hooks/useModuleInfo";
import { addonIdToFeature, Modules } from "../util/constants";

function useAddon(addonId) {
  const shortCode = useShortCode();
  const { data: availableAddons, loading } = useFetch(
    SubscriptionService.getAvailableAddons,
    { shortCode, moduleName: Modules.RECEIVABLES },
  );
  const { plan, loading: loadingSubscription } = useModuleInfo();
  const addon = availableAddons?.find((a) => a.id === addonId);
  const usage = plan?.addons?.[addonIdToFeature[addon?.id]];

  return {
    isSubscribed: Boolean(usage?.canAccess),
    addon,
    loading: loading || loadingSubscription,
  };
}

export default useAddon;
